interface IndexInfo {
  name?: string | null;
  provider?: string | null;
  ticker?: string | null;
  inception?: string | null;
  rebalance_frequency?: string | null;
}

function SectionTitle({ children }: { children: React.ReactNode }) {
  return (
    <h3 className="font-[family-name:var(--font-instrument)] text-xs leading-[1.5] tracking-[0.16em] uppercase text-[var(--etf-white2)] mb-5 flex items-center gap-2.5">
      {children}
      <span className="flex-1 h-px bg-white/[0.13]" />
    </h3>
  );
}

interface FactRowProps {
  label: string;
  value: string;
  stacked?: boolean;
}

function FactRow({ label, value, stacked }: FactRowProps) {
  if (stacked) {
    return (
      <div className="py-[9px] border-b border-[var(--etf-border2)] last:border-b-0 font-[family-name:var(--font-instrument)]">
        <div className="text-[11px] leading-[1.5] text-[var(--etf-white2)] tracking-[0.03em] mb-1">
          {label}
        </div>
        <div className="text-[11.5px] leading-[1.5] text-[var(--etf-white)]">{value}</div>
      </div>
    );
  }

  return (
    <div className="flex justify-between items-baseline gap-3 py-[9px] border-b border-[var(--etf-border2)] last:border-b-0 font-[family-name:var(--font-instrument)]">
      <span className="text-[11px] leading-[1.5] text-[var(--etf-white2)] tracking-[0.03em] shrink-0">
        {label}
      </span>
      <span className="text-right text-[11.5px] leading-[1.5] text-[var(--etf-white)]">
        {value}
      </span>
    </div>
  );
}

export function FundIndexInfo({ info }: { info: IndexInfo | null | undefined }) {
  if (!info) return null;

  const { name, provider, ticker, inception, rebalance_frequency } = info;
  const hasAnyField = name || provider || ticker || inception || rebalance_frequency;
  if (!hasAnyField) return null;

  const EMPTY = "—";

  return (
    <div
      id="sec-index-info"
      className="border-b border-white/[0.13] px-7 pt-10 pb-10 max-md:px-4 max-md:pt-7 max-md:pb-7"
    >
      <SectionTitle>Index Information</SectionTitle>
      <div>
        <FactRow label="Index Name" value={name || EMPTY} stacked />
        <FactRow label="Index Provider" value={provider || EMPTY} />
        <FactRow label="Index Ticker" value={ticker || EMPTY} />
        <FactRow label="Index Inception" value={inception || EMPTY} />
        <FactRow label="Rebalance Frequency" value={rebalance_frequency || EMPTY} />
      </div>
    </div>
  );
}
